import { JsonObject, JsonProperty } from 'json2typescript'

@JsonObject('PetClaimVetReadDto')
class PetClaimVetReadDto {
  @JsonProperty('vetTreating', String, true)
  vetTreating: string | null = null

  @JsonProperty('vetNumber', String, true)
  vetNumber: string | null = null

  @JsonProperty('vetEmail', String, true)
  vetEmail: string | null = null

  @JsonProperty('vetCity', String, true)
  vetCity: string | null = null

  @JsonProperty('vetAddress1', String, true)
  vetAddress1: string | null = null

  @JsonProperty('vetAddress2', String, true)
  vetAddress2: string | null = null

  @JsonProperty('vetAddress3', String, true)
  vetAddress3: string | null = null

  @JsonProperty('vetPostcode', String, true)
  vetPostcode: string | null = null
}

@JsonObject('ClaimPerPetReadDto')
export class ClaimPerPetReadDto {
  @JsonProperty('claimNumber', String, true)
  claimNumber: string | null = null

  @JsonProperty('claimDate', String)
  claimDate = ''

  @JsonProperty('settledDate', String, true)
  settledDate: string | null = null

  @JsonProperty('claimClosureDate', String, true)
  claimClosureDate: string | null = null

  @JsonProperty('claimProgressStatus', String, true)
  claimProgressStatus: string | null = null

  @JsonProperty('personToBePaid', String, true)
  personToBePaid: string | null = null

  @JsonProperty('actualCostOfTreatment', Number, true)
  actualCostOfTreatment: number | null = null

  @JsonProperty('labFees', Number, true)
  labFees: number | null = null

  @JsonProperty('issuePayment', String, true)
  issuePayment: string | null = null

  @JsonProperty('amountPaid', Number, true)
  amountPaid: number | null = null

  @JsonProperty('declineReason', String, true)
  declineReason: string | null = null

  @JsonProperty('conditionTreatmentType', String, true)
  conditionTreatmentType: string | null = null

  @JsonProperty('vet', PetClaimVetReadDto, true)
  vet: PetClaimVetReadDto | null = null
}

@JsonObject('ClaimGroupReadDto')
export class ClaimGroupReadDto {
  @JsonProperty('claimGroup', String)
  claimGroup = ''

  @JsonProperty('claims', [ClaimPerPetReadDto])
  claims: ClaimPerPetReadDto[] = []
}

@JsonObject('PetReadDto')
export class PetReadDto {
  @JsonProperty('prn', Number)
  prn = 0

  @JsonProperty('petDetails', String, true)
  petDetails: string | null = null

  @JsonProperty('claimGroups', [ClaimGroupReadDto])
  claimGroups: ClaimGroupReadDto[] = []
}

@JsonObject('ClaimsApiResult')
export default class ClaimsApiResult {
  @JsonProperty('policyNumber', String)
  policyNumber = ''

  @JsonProperty('pets', [PetReadDto])
  pets: PetReadDto[] = []
}
